<template>
  <div>
		<section class="client py-5" id="testimonials">
            <div class="container py-lg-5">
                <p class="paragraph">O que os clientes dizem</p>
                <h3 class="heading mb-sm-5 mb-4">Testemunhos</h3>
                <div class="row client-slider-slide">
                    <div class="col-lg-6 col-md-6 w3layouts-txt-says mb-md-0 mb-5">
                    <div class="clients-info-grid">
                        <p>Mauris elementum tortor a nisl aliquet fringilla. Donec elit ut risus augue. Proin sit amet maximus dui. Vivamus lacinia nisi tempor
                        ligula sagittis vehicula adipiscing. </p>
                        <div class="row">
                            <div class="col-lg-2 col-3 pr-0 img-position mt-3">
                            <img src="../../static/images/t1.png" alt="" class="img-fluid">
                            </div >
                            <div class=" col-lg-10 col-9 clients-txt-info">
                            <h4 class="mt-4">John Herd</h4>
                            <p>Graphic Designer</p>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="col-lg-6 col-md-6 w3layouts-txt-says">
                    <div class="clients-info-grid">
                        <p>Mauris elementum tortor a nisl aliquet fringilla. Donec elit ut risus augue. Proin sit amet maximus dui. Vivamus lacinia nisi tempor
                        ligula sagittis vehicula adipiscing. </p>
                        <div class="row">
                            <div class="col-lg-2 col-3 pr-0 img-position mt-3">
                            <img src="../../static/images/t2.png" alt="" class="img-fluid">
                            </div >
                            <div class="col-lg-10 col-9 clients-txt-info">
                            <h4 class="mt-4">Mickey</h4>
                            <p>Graphic Designer</p>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
export default {
  name: 'Clients',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Clients.vue